import React, { useState, useEffect } from "react";
import styled from "styled-components";

const ImageDialogContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const PopupWrap = styled.div`
  min-width: 30%;
  min-height: 20%;
  max-width: 80%;
  max-height: 80%;
  border: 1px solid #e4dbd2;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const PopupHeader = styled.div`
  background-color: #e4dcd3;
  font-size: 16px;
  font-weight: bold;
  height: 53px;
  line-height: 53px;
  text-align: center;
`;

const PopupContents = styled.div`
  padding: 10px;
  text-align: center;
  flex-grow: 1;
  overflow: auto;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid #ddd;
`;

const ButtonBottom = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
`;

const StyledHr = styled.hr`
  border: 1px solid #ddd;
  margin: 10px 0;
  width: 100%;
  display: block;
`;

const Comment = styled.div`
  border: 1px solid #ddd;
  padding: 10px;
`;

const ImageDialog = ({
  title,
  imageData,
  comment,
  altText = "image",
  children,
}) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (imageData instanceof Blob) {
      if (!imageData.type.startsWith("image/")) {
        return;
      }
      const url = window.URL.createObjectURL(imageData);
      setImageUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [imageData]);

  return (
    <ImageDialogContainer>
      <PopupWrap>
        <PopupHeader>{title}</PopupHeader>
        <PopupContents>
          <ImageWrapper>
            {imageUrl ? (
              <StyledImage src={imageUrl} alt={altText} />
            ) : (
              <p>Can't load image.</p>
            )}
          </ImageWrapper>
          <Comment>{comment}</Comment>
        </PopupContents>
        <StyledHr />
        <ButtonBottom>{children}</ButtonBottom>
      </PopupWrap>
    </ImageDialogContainer>
  );
};

export default ImageDialog;
